import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Star } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { api } from "@/lib/api";
import { Stars } from "./shared";

export const EvaluationBlock = ({ lead, onChanged }) => {
  const existing = lead.payload?.evaluation;
  const indicatedId = lead.payload?.indicated_partner?.partner_id || "";
  const [partners, setPartners] = useState([]);
  const [partnerId, setPartnerId] = useState(existing?.partner_id || indicatedId);
  const [rating, setRating] = useState(existing?.rating || 0);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setPartnerId(
      lead.payload?.evaluation?.partner_id ||
        lead.payload?.indicated_partner?.partner_id ||
        ""
    );
    setRating(lead.payload?.evaluation?.rating || 0);
  }, [lead?.id]);

  useEffect(() => {
    api
      .get("/admin/partners")
      .then((r) => setPartners(r.data))
      .catch(() => {});
  }, []);

  const save = async () => {
    if (!partnerId || !rating) {
      toast.error("Escolha o prestador e a nota da execução.");
      return;
    }
    setSaving(true);
    try {
      await api.patch(`/admin/leads/${lead.id}`, {
        evaluation: { partner_id: partnerId, rating },
      });
      toast.success("Avaliação registrada — entra na ficha do prestador.");
      onChanged();
    } catch {
      toast.error("Falha ao registrar avaliação.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="mt-3 rounded-xl border border-amber-200 bg-amber-50/50 p-4"
      data-testid="evaluation-block"
    >
      <p className="text-[0.65rem] font-semibold uppercase tracking-wider text-slate-400">
        Avaliação da execução
      </p>
      {existing && (
        <p className="mt-1.5 flex items-center gap-2 text-xs font-medium text-slate-600">
          Avaliado: <Stars value={existing.rating} /> por {existing.partner_name}
        </p>
      )}
      <div className="mt-3 flex flex-wrap items-center gap-3">
        <Select value={partnerId} onValueChange={setPartnerId}>
          <SelectTrigger
            className="h-9 w-[200px] rounded-full bg-white text-xs"
            data-testid="evaluation-partner-select"
          >
            <SelectValue placeholder="Quem executou?" />
          </SelectTrigger>
          <SelectContent>
            {partners.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <span className="inline-flex items-center gap-0.5">
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => setRating(n)}
              aria-label={`Nota ${n}`}
              data-testid={`evaluation-star-${n}`}
              className="rounded p-0.5 transition-transform hover:scale-125"
            >
              <Star
                className={`h-5 w-5 ${n <= rating ? "fill-amber-400 text-amber-400" : "text-slate-300 hover:text-amber-300"}`}
              />
            </button>
          ))}
        </span>
        <button
          onClick={save}
          disabled={saving}
          data-testid="evaluation-save-button"
          className="inline-flex h-9 items-center rounded-full bg-petrol px-4 text-xs font-semibold text-white transition-colors hover:bg-brand disabled:opacity-60"
        >
          {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "Salvar avaliação"}
        </button>
      </div>
    </div>
  );
};
